import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
export function DFResults() {
  return <section className="bg-black py-[60px] lg:py-[100px] overflow-hidden" data-id="element-920">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-921">
        <div className="flex flex-col-reverse lg:flex-row items-center gap-12 lg:gap-20" data-id="element-922">
          {/* Left Column - Image */}
          <AnimateOnScroll className="w-full lg:w-[45%]" delay={200} data-id="element-923">
            <div className="relative w-full aspect-[3/4] overflow-hidden shadow-xl" data-id="element-924">
              <img src="https://cdn.magicpatterns.com/uploads/4qUvFyzSSnZvaWXbpPtx3a/AdobeStock_257206406-4.webp" alt="Be CLINICAL Staff - Natural Looking Results" className="w-full h-full object-cover" data-id="element-925" />
            </div>
          </AnimateOnScroll>

          {/* Right Column - Text */}
          <AnimateOnScroll className="w-full lg:w-[55%]" data-id="element-926">
            <h2 className="text-[26px] lg:text-[40px] uppercase text-white leading-tight mb-4 font-[600] font-[Poppins,_sans-serif]" data-id="element-927">
              ENJOY NATURAL LOOKING RESULTS
            </h2>

            <div className="w-[40px] h-[2px] bg-[#FF1493] mb-8" data-id="element-928"></div>

            <div className="space-y-6 text-[#B0B0B0] text-base leading-[1.8] font-body mb-10" data-id="element-929">
              <p data-id="element-930">
                Be CLINICAL emphasizes a natural-looking approach when utilizing
                dermal fillers. Our philosophy centers on creating customized
                treatment plans for each client, taking into account individual
                facial anatomy, features and cosmetic goals. Dr. Fiona and her
                staff are constantly advancing their techniques with training
                and education about dermal fillers and injectables like Botox.
              </p>
              <p data-id="element-931">
                We prioritize a conservative approach to avoid overfilling and
                aim for subtle enhancements that complement our client's natural
                beauty. Through a thorough understanding of facial anatomy and
                precise filler placement, we strive to achieve balanced and
                symmetrical results that refresh the appearance without creating
                an artificial or exaggerated look.
              </p>
            </div>

            <p className="font-serif italic text-[#FF1493] text-[28px]" data-id="element-932">
              Treat yourself!
            </p>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}